exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".referral-codes__form-row {\n  display: flex;\n  align-items: center;\n  padding-bottom: 1rem; }\n  .referral-codes__form-row .o-textbox {\n    margin-right: .5rem; }\n", "", {"version":3,"sources":["/home/vsts/work/1/s/src/containers/ReferralCodesPage/src/containers/ReferralCodesPage/ReferralCodesPage.scss"],"names":[],"mappings":"AACA;EACI,cAAa;EACb,oBAAmB;EACnB,qBAAoB,EAKvB;EARD;IAMQ,oBAAmB,EACtB","file":"ReferralCodesPage.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.referral-codes__form-row {\n    display: flex;\n    align-items: center;\n    padding-bottom: 1rem;\n\n    .o-textbox {\n        margin-right: .5rem;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/home/vsts/work/1/s/src/scss"]}!./src/containers/ReferralCodesPage/ReferralCodesPage.scss
// module id = 590
// module chunks = 0